// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hWz8s","col":"styles_col__Ux7-r"};